import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "./Assets/css/Style.css"
import "./Assets/css/FontAwesome/Css/all.min.css"
import "./Assets/css/FontAwesome/Css/fontawesome.min.css"
import 'cropperjs/dist/cropper.min.css'
import 'react-loading-skeleton/dist/skeleton.css'
import "./Assets/css/Dashboard.css"
import "./Assets/css/Profile.css"
import "./Assets/css/Scan.css"
import "./Assets/css/Article.css"
import "./Assets/css/Campaign.css"
import "./Assets/css/Documents.css"
import "./Assets/css/BPCalibration.css"
import "./Assets/css/Languageselector.css"
import "./Components/Header.css"
import "./Styles/FaceScanning.css"
import "./Styles/ScanResults.css"
import { SkeletonTheme } from 'react-loading-skeleton';
import AppRouter from './Router/Route';
import Toast from './Components/Toast';
import Header from './Components/Header';
import Footer from './Components/Footer';
import { useLocation } from 'react-router-dom';
import storage from './Assets/js/Global';
import { useContext, useEffect } from 'react';
import { GlobalContext } from './Context/GlobalContext';
import ScanIssueModal from './modals/ScanIssueModal';

// Initialize window.showToast as a no-op to prevent crashes if called before Toast mounts
window.showToast = (type, message) => {
  console.log(`Toast (${type}): ${message}`);
};

const GlobalScanIssueModal = () => {
  const { scanIssueModal, setScanIssueModal, translatedLabels } = useContext(GlobalContext);
  const c = translatedLabels?.common || {};
  const v = (k, fb) => c?.[k]?.label_value || fb;
  const content = {
    verificationUnavailable: {
      title: v("verification_unavailable_title", "Face Verification Unavailable"),
      body: v("verification_unavailable_body", "The face checks couldn't load or stopped working. No measurements were saved."),
      footer: v("verification_unavailable_footer", "Close other camera or browser tabs, then try again."),
    },
    measurementInconclusive: {
      title: v("measurement_inconclusive_title", "Measurement Inconclusive"),
      body: v("measurement_inconclusive_body", "There wasn't enough clear pulse signal to produce reliable results. No measurements were saved."),
      footer: v("measurement_inconclusive_footer", "Please try again when you're comfortable and the lighting is steady."),
    },
    verificationFailed: {
      title: v("face_verification_failed_title", "Face Verification Unsuccessful"),
      body: v("face_verification_failed_body", "We couldn't confirm a live face for this scan. No measurements were saved."),
      footer: v("face_verification_failed_footer", "Please scan your face directly, without a photo or screen in front of the camera."),
    },
    lowQuality: {
      title: v("unreliable_signal_title", "Unreliable Signal"),
      body: v("unreliable_signal_body", "We couldn't get a reliable signal from your face, so we can't continue the face scan. Please try again."),
      footer: v("unreliable_signal_footer", "If you see this again, try in normal room lighting and avoid having bright light directly behind you"),
    },
    timeout: {
      title: v("scan_timeout_title", "No Face Detected"),
      body: v("scan_timeout_body", "No face was detected, so we can't continue the face scan. Please try again."),
      footer: v("scan_timeout_footer", "Make sure your face is clearly visible and centered in the frame before scanning."),
    },
    blinkNotDetected: {
      title: v("blink_not_detected_title", "No Blink Detected"),
      body: v("blink_not_detected_body", "We couldn't detect a blink during your scan. This helps us confirm you're ready for an accurate reading"),
      footer: v("blink_not_detected_footer", "Please look directly at the camera and blink naturally when prompted."),
    },
  };
  return (
    <ScanIssueModal
      show={!!scanIssueModal}
      onClose={() => setScanIssueModal(null)}
      onRetry={() => setScanIssueModal(null)}
      title={content[scanIssueModal]?.title}
      body={content[scanIssueModal]?.body}
      footer={content[scanIssueModal]?.footer}
      buttonText={v("scan_again", "Scan Again")}
    />
  );
};

const App = () => {
  const location = useLocation();
  const authRoutes = [
    '/',
    '/login',
    '/login-v2',
    '/password',
    '/forgot-password',
    '/verify-otp',
    '/signup/wellness-interests',
    '/reset-password',
    '/biometric-required',
    '/delete-account',
    '/signup/account-details',
    '/signup/physical-profile',
    '/signup/lifestyle',
    '/signup/wellness-priorities',
    '/welcome-back',
    '/qr-scanner',
    '/web-face-scan',
    '/bp-calibration',
    // '/plan-expired'
  ];

  if (
    location.pathname !== "/history" &&
    location.pathname !== "/user-scan-details"
  ) {
    storage.remove("lastSelectedDate");
  }
  useEffect(() => {
    const companyId = process.env.REACT_APP_COMPANY_ID;
    const title = companyId === '0it02f' ? "Healthy 4Life AI" : "GlobalHealth Check AI";
    const description = companyId === '0it02f' ? "Healthy 4Life AI" : "GlobalHealth Check AI App is an innovative easy-to-use wellness tool.";

    document.title = title;
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    }

    const favicon = companyId === '0it02f' ? "favicon4life.ico" : "favicon.ico";
    const faviconLink = document.querySelector('link[rel="icon"]');
    if (faviconLink) {
      faviconLink.setAttribute('href', `%PUBLIC_URL%/${favicon}`.replace('%PUBLIC_URL%', process.env.PUBLIC_URL || ''));
    }

    const appleTouchIcons = document.querySelectorAll('link[rel="apple-touch-icon"]');
    appleTouchIcons.forEach(icon => {
      icon.setAttribute('href', `%PUBLIC_URL%/${favicon}`.replace('%PUBLIC_URL%', process.env.PUBLIC_URL || ''));
    });

  }, []);

  const hideFooterRoutes = ['/guest-scan', '/start-scan', '/scan-logs', '/scan-guidelines'];

  const hideHeaderFooter =
    authRoutes.includes(location.pathname) ||
    location.pathname.startsWith('/scan/') ||
    location.pathname.startsWith('/invite/') ||
    location.pathname.startsWith('/invite-language/') ||
    (location.pathname === '/scan-guidelines' && !!location.state?.campaignCode);

  const hideFooter =
    hideHeaderFooter || hideFooterRoutes.includes(location.pathname);
  return (
    <SkeletonTheme baseColor="#e9eef3" highlightColor="#f5f8fb" borderRadius={8}>
      <Toast />
      <GlobalScanIssueModal />
      {!hideHeaderFooter && <Header />}
      <div
        className={!hideHeaderFooter ? "main-content-with-sidebar" : ""}
      >
        <AppRouter />
      </div>
      {!hideFooter && <div className="d-lg-none"><Footer /></div>}
    </SkeletonTheme>
  )
}

export default App;
